<div class="pagination-container">
  <ul class="pages">
    <li
      (click)="skipToBeginning()"
      class="page-indicator skip"
      [class.disabled]="selectedIndex === 0"
      *ngIf="totalPages > 4">
      <img [src]="'assets/icons/grey/Double Chevron Left.svg'" />
    </li>
    <li (click)="previousClicked()" class="page-indicator nav" [class.disabled]="selectedIndex === 0">
      <img [src]="'assets/icons/grey/Chevron Left.svg'" />
    </li>
    <li class="paginator-button pt-2" *ngIf="visiblePages[0] > 0">
      <img class="ellipsis" [src]="'assets/icons/dark/Ellipses-Horizontal.svg'" />
    </li>
    <li
      *ngFor="let pageIndex of visiblePages"
      (click)="pageClicked(pageIndex)"
      [class.active]="selectedIndex === pageIndex"
      class="page-indicator">
      <div class="page-number">{{ pageIndex + 1 }}</div>
    </li>
    <li class="paginator-button pt-2" *ngIf="visiblePages[visiblePages.length - 1] < totalPages - 1">
      <img class="ellipsis" [src]="'assets/icons/dark/Ellipses-Horizontal.svg'" />
    </li>
    <li (click)="nextClicked()" class="page-indicator nav" [class.disabled]="selectedIndex === totalPages - 1">
      <img [src]="'assets/icons/grey/Chevron Right.svg'" />
    </li>
    <li
      (click)="skipToEnd()"
      class="page-indicator skip"
      [class.disabled]="selectedIndex === totalPages - 1"
      *ngIf="totalPages > 4">
      <img [src]="'assets/icons/grey/Double Chevron Right.svg'" />
    </li>
  </ul>
</div>
